import { Link } from 'react-router-dom';
import PageShell from '../components/PageShell';

export default function NotFound() {
  return (
    <PageShell>
      <section className="page-hero not-found">
        <p className="eyebrow">SIGNAL LOST / 404</p>
        <h1 className="shimmer-text">This link drifted away</h1>
        <p>The page you requested does not exist or has moved into the archive.</p>
        <Link className="primary-button" to="/">Return home</Link>
      </section>
    </PageShell>
  );
}